export const FETCH_FORMATEURS = 'FETCH_FORMATEURS'
export const SET_FORMATEURS = 'SET_FORMATEURS'
